import { useConfirmDeletePositionContext } from './ConfirmDeletePositionContext';

const ConfirmDeletePositionModal = () => {
  const {
    confirmDeletePositionsModal: {
      CancelChangesModal,
      isVisible,
      hideCanceledModal,
    },
    confirmDeletePosition,
  } = useConfirmDeletePositionContext();

  return (
    <CancelChangesModal
      isVisible={ isVisible }
      hideCanceledModal={ hideCanceledModal }
      cancelChanges={ confirmDeletePosition }
      title="Delete Positions"
      modalTitle="Delete Positions"
      modalText="Are you sure you want to delete the selected position(s) from this list? This action is irreversible."
    />
  );
};

export default ConfirmDeletePositionModal;
